/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { Swiper, Navigation } from 'swiper';

function setNavDisabled(btn, isDisabled) {
  btn.classList.toggle('disabled', isDisabled);
  btn.disabled = isDisabled;
  btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
}

function initCarouselRoot(rootEl) {
  const swiperEl = rootEl.querySelector('.carousel__swiper');
  if (!swiperEl) {
    return;
  }

  const prevEl = rootEl.querySelector('.carousel__nav--prev');
  const nextEl = rootEl.querySelector('.carousel__nav--next');
  if (!prevEl || !nextEl) {
    return;
  }

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    swiperEl.classList.add('carousel__swiper--centered');
    setNavDisabled(prevEl, true);
    setNavDisabled(nextEl, true);
    return;
  }

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: false,
    watchOverflow: true,
    centerInsufficientSlides: true,
    breakpoints: {
      480: {
        slidesPerView: 'auto',
        spaceBetween: 32,
      },
    },
    navigation: {
      prevEl,
      nextEl,
    },
    on: {
      init(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      resize(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      slideChange(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      fromEdge(swiperInstance) {
        setNavDisabled(prevEl, swiperInstance.isBeginning);
        setNavDisabled(nextEl, swiperInstance.isEnd);
      },
      reachBeginning() {
        setNavDisabled(prevEl, true);
      },
      reachEnd() {
        setNavDisabled(nextEl, true);
      },
    },
  });

  setNavDisabled(prevEl, swiper.isBeginning);
  setNavDisabled(nextEl, swiper.isEnd);
}

function initAllCarousels() {
  document.querySelectorAll('.carousel').forEach((rootEl) => {
    initCarouselRoot(rootEl);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllCarousels();
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-carousel', () => {
      initAllCarousels();
    });
  }
});
